import createReactRoutes from '@easyvaas/create-react-routes';
import Index from './views/Index';
import History from './views/History';
import Rules from './views/Rules';
import Popup from './views/Popup';

export const imagesV3Views = createReactRoutes({
  index: Index,
  history: History,
  rules: Rules,
  popup: Popup
});
